import Solid from 'solid-payment';

import apiClientInstaller from '../ApiClient/installer';

const SolidPaymentService = () => {
    return Solid.initWithApiClient(apiClientInstaller({ extendResponse: false }));
};

export default SolidPaymentService();
